import { Card } from "antd";
import { Dispatch, SetStateAction } from "react";
import Flex from "../../../components/Flex";
import { SubmittedOrderModalPayload } from "../OrderContextMenu/CoverWizardModal/components/SubmittedOrderModal";
import { ListOrdersPayloadDto } from "../../../store/actions/dtos/ListOrdersPayloadDto";
import { OrderActionsBar } from "./OrderActionsBar";
import { OrderSearchForm } from "./OrderSearchForm";
import { OrderGroupFilters } from "./OrderGroupFilters";

type OrdersSearchCardProps = {
  newOrderButton: boolean;
  newRgaButton: boolean;
  cloneOrderButton: boolean;
  newHardwareOrderButton: boolean;
  replacementLookup: boolean;
  setPoolToolWizardPayload: (payload: any) => void;
  onSearch: (values?: Partial<ListOrdersPayloadDto>) => void;
  submittedModalPayloadState: [
    SubmittedOrderModalPayload | null,
    Dispatch<SetStateAction<SubmittedOrderModalPayload | null>>,
  ];
  groupFilters: string[];
  selectedGroupsFilters: string[];
  onGroupFilterChange: (groups: string[]) => void;
  onViewAll: () => void;
  onReplacementLookup: () => void;
};

export function OrdersSearchCard({
  newOrderButton,
  newRgaButton,
  cloneOrderButton,
  newHardwareOrderButton,
  replacementLookup,
  setPoolToolWizardPayload,
  onSearch,
  submittedModalPayloadState,
  groupFilters,
  selectedGroupsFilters,
  onGroupFilterChange,
  onViewAll,
  onReplacementLookup,
}: OrdersSearchCardProps) {
  return (
    <Card>
      <Flex vertical gap={16} align="flex-end">
        <OrderActionsBar
          newOrderButton={newOrderButton}
          newRgaButton={newRgaButton}
          cloneOrderButton={cloneOrderButton}
          newHardwareOrderButton={newHardwareOrderButton}
          replacementLookup={replacementLookup}
          setPoolToolWizardPayload={setPoolToolWizardPayload}
          submittedModalPayloadState={submittedModalPayloadState}
          onReplacementLookup={onReplacementLookup}
          onRefresh={() => onSearch()}
        />
        <OrderSearchForm onSearch={onSearch} />
        <OrderGroupFilters
          groupFilters={groupFilters}
          selectedGroupsFilters={selectedGroupsFilters}
          onGroupFilterChange={onGroupFilterChange}
          onViewAll={onViewAll}
        />
      </Flex>
    </Card>
  );
}
